export const NOTIFY_MESSAGE = 'notification/NOTIFY_MESSAGE';
